module.exports = __webpack_public_path__ + "img/computadora.0f1570c7.png";